import { jsx as _jsx } from "react/jsx-runtime";
import { Button, EButtonSize, EButtonColor, } from "../../../../Button";
import { Tooltip, ETooltipPosition, } from "../../../../Tooltip";
import IsLoadingIcon from '@mui/icons-material/Autorenew';
export const MapButton = (props) => {
    const { sx = {}, label, title, icon, isLoading, disabled = false, onClick, } = props;
    return (_jsx(Tooltip, { title: title, position: ETooltipPosition.LEFT, children: _jsx(Button, { sx: Object.assign({ borderRadius: 0, marginBottom: theme => theme.spacing(1) }, sx), size: EButtonSize.MEDIUM, color: EButtonColor.PRIMARY, icon: isLoading ? _jsx(IsLoadingIcon, {}) : icon, disabled: isLoading || disabled, onClick: onClick, children: label }) }));
};
